import { IonItem, IonLabel, IonList, IonNote, IonSelect, IonSelectOption } from "@ionic/react";
import "./selector.css";

export interface ISelectorOption {
    id: number;
    key: string;
    description: string;
}

interface ISelectorProps {
    label: string;
    options: ISelectorOption[];
    onChange: (ev: any) => any;
    selectedKey: string;
    disabled?: boolean;
}
export const Selector: React.FC<ISelectorProps> = ({ label, onChange, options, selectedKey, disabled }) => {
    return (
        <IonItem>
            <IonLabel position="floating">{label}</IonLabel>
            <IonSelect
                interface="popover"
                onIonChange={onChange}
                value={selectedKey}
                disabled={disabled}
                interfaceOptions={{}}
            >
                {options.map((item) => {
                    return (
                        <IonSelectOption
                            key={item.id}
                            value={item.key}
                        >
                            {item.description}
                        </IonSelectOption>
                    );
                })}
            </IonSelect>
        </IonItem>
    );
};
